import React, {useEffect} from 'react'
import { paraventiConfiguration } from "../Utils/meshesConfiguration";
import { useSelector, useDispatch } from 'react-redux';
import { setLunghezzaParaventi } from "../../Redux/UIMenus/uiParaventiMenuSlice";
import { E_MainLato } from "../Utils/enumerations";

import ClonedObject from "../Utils/ClonedObject";
import { generateParaventi, getLatiParaventi } from './ParaventiConf';

// Genera i paraventi
export default function Paraventi() {    
    const lunghezzaPavimento = useSelector(state => state.uiMainMenu.lunghezza) * 1;
    const larghezzaPavimento = useSelector(state => state.uiMainMenu.larghezza) * 1;
    const altezzaPavimento = useSelector(state => state.uiPedanaMenu.realAltezza);                           
    const isParaventiVisible = useSelector(state => state.uiParaventiMenu.isVisible);
    const selectedParavento = useSelector(state => state.uiParaventiMenu.tipoParavento);
    const latiTotaliParaventi = useSelector(state => state.uiParaventiMenu.latiParaventi);
    const ingresso = useSelector(state => state.uiMainMenu.ingresso);    
    const isPedanaVisible = useSelector(state => state.uiPedanaMenu.isVisible);
    const genereOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.genereOmbrellone);
    const latoOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.latoOmbrelloni);
    const dataOmbrelloni = useSelector(state => state.uiOmbrelloniMenu.dataOmbrelloni);
    const isOmbrelloniVisible = useSelector(state => state.uiOmbrelloniMenu.isVisible);

    const tipoParavento = paraventiConfiguration.find(el => el.meshName.toString() === selectedParavento.toString());  
    const indexParavento = paraventiConfiguration.findIndex(parav => parav.meshName.toString() === tipoParavento.meshName.toString());
    const latiSelezionatiParaventi = latiTotaliParaventi.filter(el => el.parav === true);

    // Lancia la generazione dei paraventi
    let paraventiArray = generateParaventi(lunghezzaPavimento, larghezzaPavimento, isPedanaVisible ? altezzaPavimento : 0, latiSelezionatiParaventi, tipoParavento, ingresso, {isVisible: isOmbrelloniVisible, latoOmbrelloni: latoOmbrelloni, dataOmbrelloni: dataOmbrelloni}, genereOmbrelloni);
   
    const dispatch = useDispatch();
    
    // I lati dei paraventi
    const hasLato1 = "hasLato1";
    const hasLato2 = "hasLato2";
    const hasLato3 = "hasLato3";
    const hasLato4 = "hasLato4";
    
    // Calculate length
    let totalParaventiLength = 0; 

    useEffect(() => {
        getTotalLength();
        dispatch(setLunghezzaParaventi(totalParaventiLength.toFixed(2)));    
        }, [lunghezzaPavimento, larghezzaPavimento, isParaventiVisible, latiTotaliParaventi, ingresso, isPedanaVisible, dataOmbrelloni, dispatch]
    );
    
    // Calcola la lunghezza totale del perimetro dei paraventi selezionati
    const getTotalLength = () => { 
        const latiParav = getLatiParaventi();      
        // Nessun ingresso
        if (ingresso.toString() === E_MainLato.Scegli.toString()) {
            if (latiParav[hasLato1] === true)
                totalParaventiLength += larghezzaPavimento;
            if (latiParav[hasLato2] === true)
                totalParaventiLength += lunghezzaPavimento;
            if (latiParav[hasLato3] === true)
                totalParaventiLength += larghezzaPavimento;           
            if (latiParav[hasLato4] === true)
                totalParaventiLength += lunghezzaPavimento;
        }
        // Con ingresso
        if (ingresso.toString() !== E_MainLato.Scegli.toString()) {
            if (latiParav[hasLato1] === true && ingresso.toString() !== E_MainLato.Lato1.toString())
                totalParaventiLength += larghezzaPavimento;
            else if (latiParav[hasLato1] === true && ingresso.toString() === E_MainLato.Lato1.toString())
                totalParaventiLength += larghezzaPavimento - 1; 
            if (latiParav[hasLato2] === true && ingresso.toString() !== E_MainLato.Lato2.toString())
                totalParaventiLength += lunghezzaPavimento;
            else if (latiParav[hasLato2] === true && ingresso.toString() === E_MainLato.Lato2.toString())
                totalParaventiLength += lunghezzaPavimento - 1;    
            if (latiParav[hasLato3] === true && ingresso.toString() !== E_MainLato.Lato3.toString())
                totalParaventiLength += larghezzaPavimento;   
            else if (latiParav[hasLato3] === true && ingresso.toString() === E_MainLato.Lato3.toString())
                totalParaventiLength += larghezzaPavimento - 1;   
            if (latiParav[hasLato4] === true && ingresso.toString() !== E_MainLato.Lato4.toString())
                totalParaventiLength += lunghezzaPavimento;   
            else if (latiParav[hasLato4] === true && ingresso.toString() === E_MainLato.Lato4.toString())
                totalParaventiLength += lunghezzaPavimento - 1; 
        } 
    }
   
    return (
        <group>
            {paraventiArray.map(
                (element, index) => {
                    if (element.pos !== undefined && element.rot !== undefined && element.sc !==  undefined) {
                        return <ClonedObject key={`${paraventiConfiguration[indexParavento].meshName.toString()}_${index}`} mesh={paraventiConfiguration[indexParavento].mesh} position={element.pos} rotation={element.rot} scale={element.sc} />
                    } else return <></>
                })}                  
        </group>      
    )
}
